import { SendValidationRequest  } from "@/services/send-validation/sendValidationService";


export function useSendValidation() {
  const sendValidationFiado = async (req: SendValidationRequest) => {
    const result = await fetch(`/api/send-validation-fiado`, {
      body: JSON.stringify(req),
      method: "POST",
    });
    const { data } = await result.json();
    const resultJson = data as String;
    return resultJson;
  };
  return sendValidationFiado;
  
}